module.exports = __webpack_public_path__ + "img/hadiah-1gb.e58cb86e.png";